// Redefine tribe.tickets.utils.cleanNumber to fix a bug.
document.addEventListener("DOMContentLoaded", function (event) {
  if (
    typeof tribe === 'undefined' ||
    typeof tribe.tickets === 'undefined' ||
    typeof tribe.tickets.utils === 'undefined') {
    return;
  }

  /**
   * Removes separator characters and converts decimal character to '.'
   * So they play nice with other functions.
   *
   * @since 5.0.3
   *
   * @param {number} passedNumber The number to clean.
   * @param {string} provider The provider.
   *
   * @returns {string} The cleaned number.
   */
  tribe.tickets.utils.cleanNumber = function (passedNumber, provider) {
    let number = passedNumber;
    const format = tribe.tickets.utils.getCurrencyFormatting(provider);

    // nathan modification to fix their bug.
    // I have logged a support ticket with them to fix this.
    if (!format) {
      if ( number.indexOf(',') > -1 ) {
        number = number.replace(/,/g, '');
      }
      return number;
    }

    // If there are no number of decimals and no thousands separator we can return the number.
    if (
      0 === parseInt(format.number_of_decimals) &&
      '' === format.thousands_sep
    ) {
      return number;
    }

    // we run into issue when the two symbols are the same -
    // which appears to happen by default with some providers.
    const same = format.thousands_sep === format.decimal_point;

    if (!same) {
      if ('' !== format.thousands_sep) {
        number = number.split(format.thousands_sep).join('');
      }
      if ('' !== format.decimal_point) {
        number = number.split(format.decimal_point).join('.');
      }
    } else {
      const decPlace = number.length - (format.number_of_decimals + 1);
      number = number.substr(0, decPlace) + '_' + number.substr(decPlace + 1);
      if ('' !== format.thousands_sep) {
        number = number.split(format.thousands_sep).join('');
      }
      number = number.split('_').join('.');
    }

    return number;
  };

});
